

import { Pipe, PipeTransform } from '@angular/core';
import { PROFILE_UPDATE_FILTER } from '@app/config/profile-update-filter.enum';

@Pipe({
  name: 'profileUpdateFilterName'
})
export class ProfileUpdateFilterNamePipe implements PipeTransform {

  transform(id: string): string {

    const ix: number = PROFILE_UPDATE_FILTER.findIndex(e => e.id === id);

    if (ix !== -1)
      return PROFILE_UPDATE_FILTER[ix].label;

    return '';
  }
}
